import { RouteRecordRaw } from "vue-router";
import { PATH } from "@/core/constants/path";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.CHURNING,
    name: "CheckChurning",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.CHURNING.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.CHURNING.PERMISSIONS,
    },
    component: () => import("@/modules/Churning/views/ChurningBookings.vue"),
  },
];

export default routes;
